const STORAGE_KEYS = {
  USER: 'user',
};

export { STORAGE_KEYS };
